<template>
    <div>
        <az-toolbar>
            <az-search :filter="filtrosInterno"
                       @remove-filter="tratarEventoRemoverFiltro"
                       @simple-search="tratarEventoBuscaSimples"
                       simple-search-placeholder="Busque por: Código, tipo ajuste, órgão, conta contábil ou situação"
                       slot="simpleSearch">
            </az-search>
        </az-toolbar>

        <ajuste-listagem-tabela
            :itens="itens"
            :paginacao="$store.state.ajuste.todosAjustes.paginacao"
            :paginas="paginas"
            :total-itens="totalItens"
            @paginar="tratarEventoPaginar"/>
    </div>
</template>

<script>
    import {mapActions, mapMutations} from 'vuex'
    import _ from 'lodash'
    import {actionTypes, mutationTypes} from '@/core/constants'
    import AjusteListagemTabela from './AjusteListagemTabela'
    import AzHasPermissions from '@azinformatica/loki/src/utils/AzHasPermissions'

    export default {
        name: 'AjusteListagem',
        components: {
            AjusteListagemTabela
        },
        mounted(){
            if(!this.verificaPermissaoEdicao()){
                this.$router.push({ name: this.rotaOrigem })
            }
        },
        data() {
            return {
                filtrosInterno: this.getFiltrosInterno(),
                itens: [],
                paginas: 0,
                totalItens: 0,
                idItemParaDeletar: null,
                rotaOrigem: this.$store.state.rota.origem,
            }
        },
        methods: {
            ...mapActions({
                buscarTodosAjustes: actionTypes.AJUSTE.BUSCAR_TODOS_AJUSTES
            }),
            ...mapMutations([
                mutationTypes.AJUSTE.SET_PAGINACAO_BUSCA_TODOS_AJUSTES,
                mutationTypes.AJUSTE.SET_FILTROS_BUSCA_TODOS_AJUSTES
            ]),
            async buscar() {
                const resultado = await this.buscarTodosAjustes()
                this.setMensagemLoading('Carregando ...')
                this.itens = resultado.items
                this.paginas = resultado.totalPages
                this.totalItens = resultado.totalElements
            },
            getFiltrosInterno() {
                return _.cloneDeep(this.$store.state.ajuste.todosAjustes.filtros)
            },
            tratarEventoPaginar(paginacao) {
                this.setPaginacaoBuscaTodosAjustes(paginacao)
                this.buscar()
            },
            tratarEventoRemoverFiltro(propriedade) {
                if (this.filtrosInterno[propriedade]) {
                    this.filtrosInterno[propriedade].value = this.filtrosInterno[propriedade].default
                }
                this.buscar()
            },
            tratarEventoBuscaSimples(valor) {
                this.filtrosInterno.conteudo.value = valor
                this.setFiltrosBuscaTodosAjustes(this.filtrosInterno)
                this.buscar()
            },
            verificaPermissaoEdicao() {
                return AzHasPermissions(this.$store.state.loki.user.authorities, ['Patrimonio.Normal'])
            }
        }
    }
</script>
